import { render, staticRenderFns } from "./PSDPreviewBadge.vue?vue&type=template&id=281d952a&scoped=true"
import script from "./PSDPreviewBadge.vue?vue&type=script&lang=js"
export * from "./PSDPreviewBadge.vue?vue&type=script&lang=js"
import style0 from "./PSDPreviewBadge.vue?vue&type=style&index=0&id=281d952a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281d952a",
  null
  
)

export default component.exports